export default "/static/js/9fc0d29353c3c9840807c5ae00e75491.webp";